/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	
	var _isSP;
	var windowW = window.innerWidth;
	var prewidth = window.innerWidth;
	
	//preload
	
	(0, _module.preload)();
	
	//showMovie
	
	(0, _module.showMovie)();
	
	//toggleHeader
	
	(0, _module.toggleHeader)();
	
	// pageTop
	
	(0, _module.pageTop)();
	
	// $(window).on('resize load' , function() {
	//   if(windowW <= 1024){
	//     _isSP = true;
	//   } else {
	//     _isSP = false;
	//   };
	
	//   //リサイズ処理 ブレイクポイントを跨いだらリロード
	//   var nowWidth = window.innerWidth;
	//   if(prewidth !== nowWidth){
	//     if(prewidth < 1025) {
	//       if(nowWidth >= 1025){
	//         location.reload();
	//       }
	//     }else {
	//       if(nowWidth < 1025){
	//         location.reload();
	//       }
	//     }
	//   };
	// });
	
	
	$(window).on('load', function () {
	
	  toggleBox();
	  scrollCommonAnime();
	  allCheck();
	});
	
	// ------------------------------------------------------------------------
	// toggleBox
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleBox = function toggleBox() {
	  $("#add-Term").on("click", function () {
	    $("#add-Term_Contents").toggleClass("is-show");
	    $(this).toggleClass("opened");
	  });
	};
	
	// ------------------------------------------------------------------------
	// allCheck
	// ----- BOTH
	// ------------------------------------------------------------------------
	var allCheck = function allCheck() {
	  $(".checkbox-List li input.allcheck").change(function (e) {
	    $(this).prop("checked") && ($(this).parents(".checkbox-List").find("input").prop("checked", !1), $(this).prop("checked", !0));
	  }), $(".checkbox-List li input:not(.allcheck)").change(function (e) {
	    $(this).prop("checked") && $(this).parents(".checkbox-List").find("input.allcheck").prop("checked", !1);
	  });
	};
	
	// ------------------------------------------------------------------------
	// scrollCommonAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	var scrollCommonAnime = function scrollCommonAnime() {
	
	  var controller = new ScrollMagic.Controller();
	
	  //ヘッダー縮める
	  var scene = new ScrollMagic.Scene({
	    triggerElement: '.index-Keyvisual',
	    triggerHook: 0,
	    offset: '100'
	  }).setClassToggle('#st-Header,#st-Header_Logo', 'short')
	  // .addIndicators({name: "1"})
	  .addTo(controller);
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu');
	
	var prewidth = window.innerWidth;
	
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preload = function preload() {
	
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	
	    $('body').addClass('preload');
	
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened');
	    stHeader.classList.remove('opened');
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed');
	    stHeader.classList.add('closed');
	
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	
	  //リサイズ処理
	  $(window).on('resize load', function () {
	    var nowWidth = window.innerWidth;
	    if (prewidth !== nowWidth) {
	      if (prewidth < 1025) {
	
	        if (nowWidth >= 1025) {
	          prewidth = window.innerWidth;
	
	          // location.reload();
	          headerFlag = false;
	          stHeaderNav.classList.remove('opened');
	          headerButton.classList.remove('opened');
	          stHeaderBg.classList.remove('opened');
	          stHeader.classList.remove('opened');
	          stHeaderNav.classList.add('closed');
	          headerButton.classList.add('closed');
	          stHeaderBg.classList.add('closed');
	          stHeader.classList.add('closed');
	        }
	      } else {
	        if (nowWidth < 1025) {
	          prewidth = window.innerWidth;
	        }
	      }
	    };
	  });
	};
	
	// ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	var toggleHeader = function toggleHeader() {
	
	  headerButton.addEventListener('click', function () {
	
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeader.classList.remove('closed');
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeader.classList.add('opened');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false;
	      // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	var showMovie = function showMovie() {
	  var $modal = $('#sw-Youtube');
	  var $content = $('#sw-Youtube_Content');
	
	  // open
	  $('.js-Youtube').on('click', function () {
	
	    var dataID = $(this).attr('data-youtube');
	
	    $('#sw-Youtube').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 500, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // fadeIn
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	
	  //close
	  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function () {
	
	    $('#sw-Youtube').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 500, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 100;
	      $('body,html').stop().animate({ scrollTop: position }, 500);
	    }, 200);
	  }
	
	  var linkSpeed = 1000;
	  var linkAdjust = 100;
	
	  //ページ内リンク
	  $("a[href^='#']").on("click", function () {
	
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	
	    $("html, body").animate({ scrollTop: linkPosition - linkAdjust }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	var pageTop = function pageTop() {
	
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({ scrollTop: 0 }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// tabSwitching
	// ----- BOTH
	// ------------------------------------------------------------------------
	var tabSwitching = function tabSwitching() {
	  document.addEventListener('DOMContentLoaded', function () {
	    // タブに対してクリックイベントを適用
	    var tabs = document.getElementsByClassName('tab-link');
	    for (var i = 0; i < tabs.length; i++) {
	      tabs[i].addEventListener('click', tabSwitch, false);
	    }
	
	    // タブをクリックすると実行する関数
	    function tabSwitch() {
	      // タブのclassの値を変更
	      document.getElementsByClassName('current-cat')[0].classList.remove('current-cat');
	      this.classList.add('current-cat');
	      // コンテンツのclassの値を変更
	      document.getElementsByClassName('is-show')[0].classList.remove('is-show');
	      var arrayTabs = Array.prototype.slice.call(tabs);
	      var index = arrayTabs.indexOf(this);
	      document.getElementsByClassName('panel-content')[index].classList.add('is-show');
	    };
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// movieSwitching
	// ----- BOTH
	// ------------------------------------------------------------------------
	var movieSwitching = function movieSwitching() {
	  document.addEventListener('DOMContentLoaded', function () {
	    // タブに対してクリックイベントを適用
	    var tabs2 = document.getElementsByClassName('index-Movie_List_Item');
	    for (var i = 0; i < tabs2.length; i++) {
	      tabs2[i].addEventListener('click', movieSwitch, false);
	    }
	
	    // タブをクリックすると実行する関数
	    function movieSwitch() {
	      // タブのclassの値を変更
	      document.getElementsByClassName('current-movie')[0].classList.remove('current-movie');
	      this.classList.add('current-movie');
	      // コンテンツのclassの値を変更
	      document.getElementsByClassName('is-show-movie')[0].classList.remove('is-show-movie');
	      var arrayTabs2 = Array.prototype.slice.call(tabs2);
	      var index2 = arrayTabs2.indexOf(this);
	      document.getElementsByClassName('sw-Movie_Item')[index2].classList.add('is-show-movie');
	    };
	  }, false);
	};
	
	exports.preload = preload;
	exports.toggleHeader = toggleHeader;
	exports.showMovie = showMovie;
	exports.anchorLink = anchorLink;
	exports.pageTop = pageTop;
	exports.tabSwitching = tabSwitching;
	exports.movieSwitching = movieSwitching;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// cards/app.bundle.js